import { Link as ScrollLink } from "react-scroll";
import ArrowIcon from "./ArrowIcon";
import styles from "../../styles/ui/Button.module.scss";

/**
 * The single call-to-action primitive used across the site.
 * Renders a react-scroll link (default) or any element via `as`,
 * so every CTA shares one set of sizing, colour and motion rules.
 */
const CtaButton = ({
  to,
  children,
  variant = "primary",
  withArrow = true,
  className = "",
  offset = -72,
  onClick,
  ...rest
}) => {
  const classes = [styles.btn, styles[variant], className]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      <span>{children}</span>
      {withArrow && <ArrowIcon className={styles.icon} />}
    </>
  );

  if (!to) {
    return (
      <button type="button" className={classes} onClick={onClick} {...rest}>
        {content}
      </button>
    );
  }

  // react-scroll renders an anchor without href, so keyboard activation
  // has to be wired up explicitly to keep the CTA operable without a mouse.
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    <ScrollLink
      to={to}
      smooth={true}
      duration={600}
      offset={offset}
      className={classes}
      tabIndex={0}
      role="link"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {content}
    </ScrollLink>
  );
};

export default CtaButton;
